module.exports = __webpack_public_path__ + "static/media/close.ae453df8.svg";